import { Container } from "react-bootstrap";
import { Administrator } from "../models/administrator";
import NotFoundPage from "./NotFoundPage";
import styles from "../styles/ProjectsPage.module.css"
import { useParams } from "react-router-dom";
import ProjectTasksPageView from "../components/AdministratorsComponents/ProjectTasksPageView"

interface AdministratorProjectTasksPageProps {
    loggedInAdministrator: Administrator | null,
}

const AdministratorProjectTasksPage = ({ loggedInAdministrator }: AdministratorProjectTasksPageProps) => {
  const {projectId} = useParams();
  return (
        <Container className={styles.projectsPage}>
        <>
          { loggedInAdministrator
              ? <ProjectTasksPageView role={loggedInAdministrator.role} projectId={projectId}/>
              : <NotFoundPage/>
          }
        </>
      </Container>
    )
}

export default AdministratorProjectTasksPage